import { render } from "./brokerage.vue?vue&type=template&id=87efbfc4"
import script from "./brokerage.vue?vue&type=script&lang=js"
export * from "./brokerage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__